var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconKayakRegular = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A202C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.562 11.27 2.543 2.545a2.152 2.152 0 0 0-2.544-2.545zM13 16.705a3.316 3.316 0 0 1-1.772-.511.59.59 0 0 1 .628-.998 2.135 2.135 0 0 0 1.583.285l-3.143-3.143a3.048 3.048 0 0 1-2.301.049c-.016.334-.024.67-.024 1.006 0 5.828 2.195 10.393 4.998 10.393 1.763 0 3.286-1.81 4.171-4.603L14.37 16.41c-.419.188-.88.295-1.37.295z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.131 10.165a.52.52 0 0 1 .08-.025 3.332 3.332 0 0 1 3.822 4.602l1.719 1.719c.138-.967.212-1.996.212-3.068C17.964 7.565 15.77 3 12.969 3c-1.278 0-2.465.939-3.365 2.626l1.76 1.76a2.94 2.94 0 0 1 .767 2.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.827 20.591a.588.588 0 0 0-.803-.025l-9.783-9.783c.59-.95.5-2.188-.292-2.98L7.694 4.547a.588.588 0 0 0-.833 0L4.173 7.235a.588.588 0 0 0 0 .833l3.255 3.256a2.32 2.32 0 0 0 1.654.677c.474 0 .928-.136 1.327-.384l9.783 9.783a.587.587 0 0 0 .442.976.587.587 0 0 0 .417-.173l.778-.778a.592.592 0 0 0-.002-.834z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconKayakRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-kayak-regular.c95c8f51.svg";
export { ForwardRef as ReactComponent };